import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeKey = $event)),
      onTabClick: _ctx.tabClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "draftManage",
          tab: "草稿管理"
        }),
        _createVNode(_component_a_tab_pane, {
          key: "templateManage",
          tab: "模版管理"
        }),
        _createVNode(_component_a_tab_pane, {
          key: "versionManage",
          tab: "版本管理"
        })
      ]),
      _: 1
    }, 8, ["activeKey", "onTabClick"]),
    _createVNode(_component_router_view)
  ]))
}